import React from "react";

const Footer = () => (
  <footer className="app-footer">
    <section className="md-cell md-cell--12 md-grid md-grid--no-spacing copyright" data-test="copy-right">
      Copyright {new Date().getFullYear()} by Mueller Services, Inc.
    </section>
  </footer>
);

export default Footer;
